import { UsersWebPageUser } from '../../types'

export const NEW_USER: UsersWebPageUser = {
  firstName: '',
  lastName: '',
  assignedRelationships: [],
  email: '',
  id: '',
  phone: '',
  active: true,
  createdAt: '',
  enableDeactivate: true,
  enableEdit: true,
  enablePasswordResetOrInvite: true,
  isCurrentUser: false,
  lastLogin: null,
  role: {
    name: '',
    key: '',
    description: ''
  },
  enableDeleteAllMFA: false
}
